<div class="insurance-premium-page container-fluid">
  <div class="mat-h2">New Insurance Premium Application</div>
  <application-stepper2 [linear]="false" #applicationStepper="applicationStepper2">
    <cdk-step [stepControl]="formGroupStep1" ><ng-content *ngTemplateOutlet="step1" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep2" ><ng-content *ngTemplateOutlet="step2" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep3" ><ng-content *ngTemplateOutlet="step3" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep4"><ng-content *ngTemplateOutlet="step4Kyb" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep6" ><ng-content *ngTemplateOutlet="step6" ></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep7" ><ng-content *ngTemplateOutlet="step7" ></ng-content></cdk-step>
    @if (requiredTrustDeeds.length) {
    <cdk-step [stepControl]="formGroupStep8" ><ng-content *ngTemplateOutlet="step8" ></ng-content></cdk-step>
    }
    <cdk-step [stepControl]="formGroupStep9" ><ng-content *ngTemplateOutlet="step9"></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep10" ><ng-content *ngTemplateOutlet="step10"></ng-content></cdk-step>
    <cdk-step [stepControl]="formGroupStep11" ><ng-content *ngTemplateOutlet="step11"></ng-content></cdk-step>
  </application-stepper2>
</div>


<!--
##########################################
#  STEP 1:
##########################################
-->
<ng-template #step1>
  <div class="step1">
    <form [formGroup]="formGroupStep1" >
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <aggregator-search
            [mandatory]="true"
            [searchFn]="step1BrokerSearchFn"
            [title]="'Introducer'"
            [formControl]="formControlStep1Broker"
            [disabled]="isExternalUser"
          [mark]="applicationStepper.markTriggerSubject(formGroupStep1)"></aggregator-search>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <salesforce-contact-same-account-selection
            title="Introducer Contact"
            [getFunc]="step1GetSalesforceContactSameAccountFn"
            [salesforceAccountId]="this.step1OrgSalesforceId"
            [formControl]="formControlStep1BrokerContact"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep1)"
            [isMandatory]="true">
          </salesforce-contact-same-account-selection>
        </div>
      </div>
      @if (!step1NoOtherUsersInCompany) {
        <div class="brokerCorrespondent">
          <div class="row mb-4">
            <div class="col-lg-6 col-md-12 showCorrespondent">
              <mat-checkbox color="primary" [formControl]="formControlStep1ShowCorrespondent">Add additional broker correspondent</mat-checkbox>
              <span
                matTooltip="Add in additional broker correspondent"
                matTooltipPosition="after"
              class="tooltip-icon mdi mdi-help-circle-outline ml-1"></span>
            </div>
          </div>
          @if (formControlStep1ShowCorrespondent.value) {
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <user-same-company-selection
                  title="Additional Broker Correspondent"
                  [getFunc]="step1GetUserSameCompanyFn"
                  [salesforceId]="this.step1OrgSalesforceId"
                  [formControl]="formControlStep1Correspondent"
                  [isMandatory]="false">
                </user-same-company-selection>
              </div>
            </div>
          }
        </div>
      }
      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Applicant's business name</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <business-search [placeholder]="businessSearchPlaceholder" [mark]="applicationStepper.markTriggerSubject(formGroupStep1)" [formControl]="formControlStep1Business" [searchFn]="step1SearchFn" [readOnly]="borrowingEntityLocked" [hint]="step1BusinessLockedHint"></business-search>
        </div>
      </div>
      <!-- NOTE: PrevBusiness doesn't apply to Insurance Premium
      @if (formControlStep1Business.value && (formControlStep1Business.value.type === 'search-result') && ($any(formControlStep1Business.value).result?.ABNAgeMonths ?? 0) < 12) {
        <div class="row mb-4">
          <div class="col-lg-6 col-md-12">
            <div class="mb-2">The ABN age for the business is less than 12 months old. Does the business owner(s) have a previous ABN with over 12 months of history?</div>
            <business-number-search
              [mark]="applicationStepper.markTriggerSubject(formGroupStep1)"
              [searchFn]="step4BusinessNumberSearchFn"
              [formControl]="formControlStep1PreviousBusiness"
            ></business-number-search>
          </div>
        </div>
      }
      -->
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 2:
##########################################
-->
<ng-template #step2>
  <div class="step2">
    <form [formGroup]="formGroupStep2"></form>
    <div class="row separator-bottom">
      <div class="col-12">
        <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
        </application-header-segment>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <policy
          [calcFn]="step2CalcFn"
          [mark]="applicationStepper.markTriggerSubject(formGroupStep2)"
          [formControl]="formControlStep2Policies">
        </policy>
      </div>
    </div>
    <loan-purpose-selection
      [formControl]="formControlStep2LoanPurpose"
      [mark]="applicationStepper.markTriggerSubject(formGroupStep2)"
      [applicationType]="applicationType">
    </loan-purpose-selection>
  </div>
</ng-template>

<!--
##########################################
#  STEP 3:
##########################################
-->
<ng-template #step3>
  <div class="step3">
    <form [formGroup]="formGroupStep3">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-12">
          <div class="application-section-title">Organisation details</div>
          <div class="mat-body">Please provide us with further details so we can provide you with a more accurate quote</div>
        </div>
      </div>

      @if (step3AwaitingKyb) {
        <div class="row">
          <div class="col-12">
            <kyb-status
              [applicationId]="applicationId"
              [active]="step3Active"
              [businessName]="organisationName"
              [pollFn]="step3KybResultFn"
              [refreshFn]="step3KybRefreshFn"
              (manualEntry)="onStep3ManualKyb()"
              (resolved)="onStep3KybResolved($event)">
            </kyb-status>
          </div>
        </div>
      } @else {
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <entity-type
            title="Organisation type"
            [readonly]="true"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3OrganisationType">
          </entity-type>
        </div>
        <div class="col-lg-3 col-md-12">
          <abn [formControl]="formControlStep3Abn" [mark]="applicationStepper.markTriggerSubject(formGroupStep3)">
          </abn>
        </div>
        @if (step3OnwardsOrganisationType && step3OnwardsOrganisationType === 'company') {
          <div class="col-lg-3 col-md-12">
            <acn
              [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
              [formControl]="formControlStep3Acn" required >
            </acn>
          </div>
        }
        @if (step3OnwardsOrganisationType === 'trust') {
          <div class="col-lg-3 col-md-12">
            <acn [formControl]="formControlStep3Acn"
              [isMandatory]="false"
              [mark]="applicationStepper.markTriggerSubject(formGroupStep3)">
            </acn>
          </div>
        }
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-12 mt-2">
          <annual-revenue title="Annual revenue" [formControl]="formControlStep3Revenue"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)">
          </annual-revenue>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12">
          <primary-industry-selection
            [getIndustryDivisionsFn]="getIndustryDivisionsFn"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3PrimaryIndustry">
          </primary-industry-selection>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <secondary-industry-selection
            [getIndustryGroupsByDivisionCodeFn]="getIndustryGroupsByDivisionCodeFn"
            [divisionCode]="step3PrimaryIndustryDivisionCode"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3IndustrySector">
          </secondary-industry-selection>
        </div>
        <div class="col-lg-6 col-md-12">
          <subdivision-industry-selection
            [getIndustryClassesByGroupCodeFn]="getIndustryClassesByGroupCodeFn"
            [groupCode]="step3IndustrySectorGroupCode"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3SubdivisionIndustrySector">
          </subdivision-industry-selection>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12">
          <custom-address
            [placesSearchResultFn]="placesSearchResultFn"
            [placesDetailsFn]="placesDetailsFn"
            title="Principal place of business address"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3PrimaryBusinessAddress">
          </custom-address>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <custom-address
            [placesSearchResultFn]="placesSearchResultFn"
            [placesDetailsFn]="placesDetailsFn"
            title="Registered business address"
            [mark]="applicationStepper.markTriggerSubject(formGroupStep3)"
            [formControl]="formControlStep3RegisteredBusinessAddress">
          </custom-address>
        </div>
      </div>
      }

    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 4:
##########################################
-->
<ng-template #step4Kyb> <!-- Key People (KYB) -->
  <div class="step4">
    <div class="row separator-bottom">
      <div class="col-12">
        <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
        </application-header-segment>
      </div>
    </div>
    <kyb-key-people
      [applicationId]="applicationId ?? 0"
      [uploadedDocuments]="applicationDocuments"
      [active]="step4Active"
      [seedResult]="step3KybResult"
      [kybResultFn]="step4KybResultFn"
      [kybRefreshFn]="step3KybRefreshFn"
      [kybSetManualModeFn]="kybSetManualModeFn"
      [kybInitiateCorporatePartyFn]="step4KybInitiateCorporatePartyFn"
      [businessNumberSearchFn]="step4BusinessNumberSearchFn"
      [organisationType]="step3OnwardsOrganisationType"
      [formControl]="formControlStep4KybKeyPeople"
      (idDocumentDelete)="onIdDocumentDelete($event)"
      (warningsChange)="step4KybWarnings = $event"
      [mark]="applicationStepper.markTriggerSubject(formGroupStep4)">
    </kyb-key-people>
  </div>
</ng-template>


<!--
##########################################
#  STEP 6:
##########################################
-->
<ng-template #step6>
  <div class="step6">
    <form [formGroup]="formGroupStep6">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <authorised-signatory
            [mark]="applicationStepper.markTriggerSubject(formGroupStep6)"
            [formControl]="formControlStep6AuthorisedSignatories">
          </authorised-signatory>
        </div>
      </div>

    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 7: Individual details review, including the primary contact selection
##########################################
-->
<ng-template #step7>
  <div class="step7">
    <form [formGroup]="formGroupStep7">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Individual Details</div>
        </div>
      </div>

      @if (applicationId) {
        <div class="row separator-bottom">
          <div class="col-12">
            <individual-details-list
              #individualDetailsListComponent
              [applicationId]="applicationId"
              [applicationType]="'InsurancePremium'"
              [idDocumentMetadata]="step9OtherDocMetadata"
              [mark]="applicationStepper.markTriggerSubject(formGroupStep7)"
              [formControl]="formControlStep7IndividualDetails">
            </individual-details-list>
          </div>
        </div>
      }
    </form>
  </div>
</ng-template>


<!--
##########################################
#  STEP 8: trust deeds
##########################################
-->
<ng-template #step8>
  <div class="step8">
    <form [formGroup]="formGroupStep8">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Trust Deed Upload</div>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <trust-deed-upload
            [formControl]="formControlStep8TrustDeeds"
            [applicationId]="applicationId ?? null"
            [requiredTrustDeeds]="requiredTrustDeeds"
            [uploadedDocuments]="step9UploadedDocs"
            (deleteUploadedDoc)="onStep8DeleteUploadedDoc($event)"></trust-deed-upload>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 9:
##########################################
-->
<ng-template #step9>
  <div class="step9">
    <form [formGroup]="formGroupStep9">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-12">
          <div class="application-section-title">Other supporting documents</div>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <uploaded-files-list   [uploadedFiles]="step9UploadedDocs" (events)="onStep9DeleteUploadedDoc($event)"></uploaded-files-list>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <upload-files-multi-tags
          #uploadFilesMultiTagsComponent="uploadFilesMultiTagsComponent"
            [allTags]="documentTypes"
            (docEvent)="onStep9DocEvent($event)"
          ></upload-files-multi-tags>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 10:
##########################################
-->
<ng-template #step10>
  <div class="step10">
    <form [formGroup]="formGroupStep10">
      <div class="row separator-bottom">
        <div class="col-12">
          <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
          </application-header-segment>
        </div>
      </div>


      <div class="row">
        <div class="col-12">
          <div class="application-section-title">Overview</div>
        </div>
      </div>

      <div class="row separator-bottom">
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Application notes </mat-label>
            <textarea matInput rows="10" wrap="hard" maxlength="7000" [formControl]="formControlStep10ApplicationNotes"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!--
##########################################
#  STEP 11:
##########################################
-->
<ng-template #step11>
  <div class="step11">
    <div class="row separator-bottom">
      <div class="col-12">
        <application-header-segment [applicationId]="brokerApplicationId" [titleValue]="organisationName">
        </application-header-segment>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <form [formGroup]="formGroupStep11">
          <insurance-premium-summary [summary]="step11Summary"></insurance-premium-summary>
        </form>
      </div>
    </div>

  </div>
</ng-template>

